import React, { useMemo } from 'react'
import { Avatar } from '@components/Avatar/Avatar'
import { ActionNavItem } from '@components/NavItem/ActionNavItem'
import { Box } from '@ui'
import { useCreateLink } from 'hooks/useCreateLink'
import { useUserLookup } from 'use-towns-client'

import { useMembersNotInDMs } from './hooks/useMembersNotInDMs'

type Props = ReturnType<typeof useMembersNotInDMs>['data'][number]

export function MemberNotInDMsNavItem(props: Props) {
    const { id } = props

    const user = useUserLookup(id)
    const hasUserName =
        user.username !== undefined && user.username !== null && user.username !== ''
    const { createLink } = useCreateLink()
    const icon = useMemo(() => {
        return (
            <Box width="x4" shrink={false}>
                <Avatar userId={id} size="avatar_x4" />
            </Box>
        )
    }, [id])

    return (
        <ActionNavItem
            exact
            key={id}
            id={id}
            label={user.isBot ? user.displayName : hasUserName ? user.username : id}
            icon={icon}
            link={createLink({ profileId: id })}
            minHeight="x5"
        />
    )
}
